(function () {
  'use strict';

  const HUMAN_ICON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>';
  const AGENT_ICON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 6V2H8"/><path d="M15 11v2"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="M20 16a2 2 0 0 1-2 2H8.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 4 20.286V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/><path d="M9 11v2"/></svg>';
  const TOOLBOX_ICON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16 12v4"/><path d="M16 6a2 2 0 0 1 1.414.586l4 4A2 2 0 0 1 22 12v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 .586-1.414l4-4A2 2 0 0 1 8 6z"/><path d="M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/><path d="M2 14h20"/><path d="M8 12v4"/></svg>';
  const ENTER_ICON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m10 16 4-4-4-4"/><path d="M3 12h11"/><path d="M3 8V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3"/></svg>';
  const EXIT_ICON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 12h11"/><path d="m17 16 4-4-4-4"/><path d="M21 6.344V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-1.344"/></svg>';

  function capitalize(str) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function normalizeList(value) {
    if (!value) return [];
    if (Array.isArray(value)) return value.map(v => String(v).trim()).filter(Boolean);
    return String(value).split(' + ').map(v => v.trim()).filter(Boolean);
  }

  function statusKeyOf(status) {
    return (status || '').toLowerCase().replace(/\s+/g, '-') || 'live';
  }

  const FLOWS = {
    'product-launch': {
      name: 'Product launch',
      slug: 'product-launch',
      description: 'End-to-end flow for launching a new SKU from initial decision through published product in all markets. The final step writes the launch record back to the context library, enriching the input for every future launch.',
      loop_note: 'Archived launch record enriches the Product launch archive loaded in step 2 of the next launch.',
      steps: [
        {
          number: 1,
          title: 'Submit initial product information',
          description: 'User submits product name, brand, website link, origin, inventory quantity, and personal tasting notes in chat',
          input: [],
          tool: ['Claude chat'],
          output: ['Launch trigger'],
          lane: 'Human',
          status: 'Live'
        },
        {
          number: 2,
          title: 'Load launch context',
          description: 'User attaches schema, blank template, brand voice rules, imagery rules, and archive files at the start of the chat. Agent reads them from the upload folder',
          input: ['Schema', 'Blank product launch template', 'Brand voice rules', 'Imagery rules', 'Product launch archive'],
          tool: ['Claude chat'],
          output: ['Launch context loaded'],
          lane: 'Human',
          status: 'Live'
        },
        {
          number: 3,
          title: 'Research product online',
          description: "Agent searches the web in the product's native languages to gather tasting notes, ingredients, nutrition, ABV, allergens, and beer style labels",
          input: ['Launch trigger'],
          tool: ['Claude chat', 'Web search'],
          output: ['Product research'],
          lane: 'Agent',
          status: 'Live'
        },
        {
          number: 4,
          title: 'Request missing information',
          description: 'Agent compares research and user input against schema requirements and prepares clarifying questions for any genuine gaps',
          input: ['Launch trigger', 'Product research', 'Schema'],
          tool: ['Claude chat'],
          output: ['Clarifying questions'],
          lane: 'Agent',
          status: 'Live'
        },
        {
          number: 5,
          title: 'Provide missing information',
          description: 'User answers clarifying questions in a single numbered message',
          input: ['Clarifying questions'],
          tool: ['Claude chat'],
          output: ['User answers'],
          lane: 'Human',
          status: 'Live'
        },
        {
          number: 6,
          title: 'Finalize product launch template',
          description: 'Agent populates every field of the blank template — copy in EN/DE/FR, image prompts, alt text, metafields, SEO — using research, user answers, brand voice rules, imagery rules, and archive references',
          input: ['Launch trigger', 'Product research', 'User answers', 'Blank product launch template', 'Brand voice rules', 'Imagery rules', 'Product launch archive'],
          tool: ['Claude chat'],
          output: ['Filled product launch template'],
          lane: 'Agent',
          status: 'Live'
        },
        {
          number: 7,
          title: 'Review filled template',
          description: 'Agent renders the filled template as a structured review document (locked format). User reviews conversationally and requests edits. On approval, agent outputs the final JSON in a code block, the five image prompts in copy-paste blocks, and the Claude Code handoff block — all in one response. User saves the JSON to Drive manually',
          input: ['Filled product launch template'],
          tool: ['Claude chat'],
          output: ['Approved JSON', 'Image prompts', 'Claude Code handoff'],
          lane: 'Human',
          status: 'Live'
        },
        {
          number: 8,
          title: 'Generate product images',
          description: 'User copies each image prompt into Gemini, attaches the reference image, generates the images, and saves them to the staging folder in Drive with role-keyword filenames',
          input: ['Image prompts'],
          tool: ['Gemini', 'Drive'],
          output: ['Raw product images'],
          lane: 'Human',
          status: 'Live'
        },
        {
          number: 9,
          title: 'Process images and finalize',
          description: "Claude Code reads the saved JSON and the staging folder. Validates JSON against schema. For each raw image: strips metadata, converts to JPEG, renames per locked filename convention, moves to the main Images folder. Updates the JSON's media array to reflect actual files",
          input: ['Approved JSON', 'Raw product images'],
          tool: ['Claude Code', 'Drive'],
          output: ['Validated JSON', 'Renamed product images'],
          lane: 'Agent',
          status: 'Live'
        },
        {
          number: 10,
          title: 'Upload product to Shopify',
          description: 'Claude Code runs the upload script. The script handles productCreate, variant, inventory, translations, image upload, collection assignment, and locked values enforcement. No confirmation gate',
          input: ['Validated JSON', 'Renamed product images'],
          tool: ['Claude Code', 'Shopify API'],
          output: ['Draft Shopify product'],
          lane: 'Agent',
          status: 'Live'
        },
        {
          number: 11,
          title: 'Verify upload and publish product',
          description: 'Agent sends the user a single message with the draft URL. User reviews across all markets in Shopify and switches status from Draft to Active. User replies "done"',
          input: ['Draft Shopify product'],
          tool: ['Claude Code', 'Shopify'],
          output: ['Published Shopify product'],
          lane: 'Human',
          status: 'Live'
        },
        {
          number: 12,
          title: 'Archive launch for future learning',
          description: 'Claude Code confirms the saved JSON is in place and reports the total archive count',
          input: ['Approved JSON'],
          tool: ['Claude Code', 'Drive'],
          output: ['Archived launch record'],
          lane: 'Agent',
          status: 'Live'
        }
      ]
    },

    'bundle-creation': {
      name: 'Bundle creation',
      slug: 'bundle-creation',
      description: 'End-to-end flow for spinning a multi-pack bundle off an existing single-SKU product — fetching the source from Shopify, asking the user for tier and vendor collection, building 6/12/24-pack variants with metafields and translations, and wiring them to subscription plans.',
      steps: [
        {
          number: 1,
          title: 'Submit launch trigger',
          description: "User submits the source single's handle (e.g. goxoa-sportsbeer-blonde-single) and any pre-known parameters (price tier, vendor collection handle).",
          input: ['Initial user information'],
          tool: ['Claude Code chat'],
          output: ['Launch trigger'],
          lane: 'Human',
          status: 'Live'
        },
        {
          number: 2,
          title: 'Load price tier rules',
          description: 'Agent reads price-tier-rules.md from Drive so the four pricing tiers are available verbatim when prompting the user later.',
          input: ['Launch trigger'],
          tool: ['Drive'],
          output: ['Price tier rules'],
          lane: 'Agent',
          status: 'Live'
        },
        {
          number: 3,
          title: 'Resolve source single',
          description: "Agent fetches the source single's full state from Shopify (title, copy, metafields, translations, media GIDs, source variant ID, SKU, publications) and validates that the handle ends with -single, the product is ACTIVE, the variant has a SKU, and the derived bundle handle is free.",
          input: ['Launch trigger'],
          tool: ['Shopify Admin API'],
          output: ['Source single snapshot'],
          lane: 'Agent',
          status: 'Live'
        },
        {
          number: 4,
          title: 'Request missing inputs',
          description: 'Agent identifies which parameters were not in the launch trigger and asks the user for them, listing the four price tiers inline with full per-pack pricing so the user does not need to memorize tier letters.',
          input: ['Launch trigger', 'Source single snapshot', 'Price tier rules'],
          tool: ['Claude Code chat'],
          output: ['Clarifying questions'],
          lane: 'Agent',
          status: 'Live'
        },
        {
          number: 5,
          title: 'Provide missing inputs',
          description: 'User answers the clarifying questions, choosing a price tier (A/B/C/D) and either a vendor collection handle or "no".',
          input: ['Clarifying questions'],
          tool: ['Claude Code chat'],
          output: ['User answers'],
          lane: 'Human',
          status: 'Live'
        },
        {
          number: 6,
          title: 'Create bundle on Shopify',
          description: "Agent runs bundle_upload.py to create the bundle product in DRAFT with templateSuffix=subscription, build 6/12/24-pack variants at the tier's prices, wire native productVariantComponents to the source's variant, copy all product and variant metafields, attach the source single's existing MediaImage records via productSet (zero file duplication), register DE and FR translations, assign manual collections (Craft Beers, vendor collection if any), and publish to the source's publications that accept bundles. The script appends a row to launches.csv as a side effect.",
          input: ['Source single snapshot', 'User answers', 'Price tier rules'],
          tool: ['bundle_upload.py'],
          output: ['Draft bundle product'],
          lane: 'Agent',
          status: 'Live'
        },
        {
          number: 7,
          title: 'Activate bundle',
          description: "User opens the bundle's storefront URL across all markets, verifies content renders correctly (variant selector shows 6/12/24-pack with correct prices, source media loads, DE/FR translations look right), then flips status from DRAFT to ACTIVE in the Shopify admin.",
          input: ['Draft bundle product'],
          tool: ['Shopify admin'],
          output: ['Published bundle'],
          lane: 'Human',
          status: 'Live'
        },
        {
          number: 8,
          title: 'Assign bundle to Appstle subscription plans',
          description: "User opens Appstle Subscriptions and adds the bundle's pack variants to the matching plans (6-pack variant → 6-Pack 4 Weeks plan, 12-pack variant → 12-Pack 4 Weeks plan, 24-pack variant → 24-Pack 4 Weeks plan). Manual today because Shopify's permission model blocks cross-app modification of Appstle-owned SellingPlanGroups, and Appstle's REST API for plan-product assignment is gated by plan tier. Once Appstle API access is available, this step can be automated by extending bundle_upload.py to call POST /api/external/v2/subscription-groups/<id>/products (or the equivalent) instead.",
          input: ['Published bundle'],
          tool: ['Appstle admin'],
          output: ['Bundle attached to subscription plans'],
          lane: 'Human',
          status: 'Live'
        }
      ]
    },

    'tech-feature': {
      name: 'Website features',
      slug: 'tech-feature',
      description: 'Build, review, and deploy website features. The iteration loop (refine → rebuild) is the point — cheap iteration is what makes AI-driven development viable.',
      steps: [
        { number: 1,  title: 'Spec',      description: '', tool: '', lane: 'Human', status: 'Live' },
        { number: 2,  title: 'Read code', description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 3,  title: 'Load repo', description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 4,  title: 'Plan',      description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 5,  title: 'Write',     description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 6,  title: 'Lint',      description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 7,  title: 'Build',     description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 8,  title: 'Preview',   description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 9,  title: 'Diff',      description: '', tool: '', lane: 'Human', status: 'Live' },
        { number: 10, title: 'Check',     description: '', tool: '', lane: 'Human', status: 'Live' },
        { number: 11, title: 'Refine',    description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 12, title: 'Approve',   description: '', tool: '', lane: 'Human', status: 'Live' },
        { number: 13, title: 'Deploy',    description: '', tool: '', lane: 'Agent', status: 'Live' }
      ]
    },

    'translations': {
      name: 'Translations (multi-market)',
      slug: 'translations',
      description: 'Translate product listings and storefront copy into all market languages using brand voice and glossary context.',
      steps: [
        { number: 1,  title: 'Brief',       description: '', tool: '', lane: 'Human', status: 'Live' },
        { number: 2,  title: 'Scope',       description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 3,  title: 'Glossary',    description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 4,  title: 'DE',          description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 5,  title: 'FR',          description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 6,  title: 'IT',          description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 7,  title: 'ES',          description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 8,  title: 'Native read', description: '', tool: '', lane: 'Human', status: 'Live' },
        { number: 9,  title: 'Save',        description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 10, title: 'Sync T&A',    description: '', tool: '', lane: 'Agent', status: 'Live' }
      ]
    },

    'customer-service': {
      name: 'Customer service (pre-sale)',
      slug: 'customer-service',
      description: 'Incoming Shopify Inbox messages are classified and answered with brand-voice drafts, reviewed by the operator when needed, then sent.',
      steps: [
        { number: 1, title: 'Msg in',       description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 2, title: 'Classify',     description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 3, title: 'Load FAQ',     description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 4, title: 'Load policy',  description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 5, title: 'Draft',        description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 6, title: 'Read',         description: '', tool: '', lane: 'Human', status: 'Live' },
        { number: 7, title: 'Edit',         description: '', tool: '', lane: 'Human', status: 'Live' },
        { number: 8, title: 'Send',         description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 9, title: 'Log',          description: '', tool: '', lane: 'Agent', status: 'Live' }
      ]
    },

    'task-management': {
      name: 'Task management & prioritization',
      slug: 'task-management',
      description: 'Scan sources, extract action items, triage and score, write back to TASKS.md, and surface the next best task.',
      steps: [
        { number: 1,  title: 'Scan',       description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 2,  title: 'Parse',      description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 3,  title: 'Extract',    description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 4,  title: 'Categorize', description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 5,  title: 'Score',      description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 6,  title: 'Review',     description: '', tool: '', lane: 'Human', status: 'Live' },
        { number: 7,  title: 'Refine',     description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 8,  title: 'TASKS.md',   description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 9,  title: 'Next up',    description: '', tool: '', lane: 'Agent', status: 'Live' },
        { number: 10, title: 'Notify',     description: '', tool: '', lane: 'Agent', status: 'Live' }
      ]
    }
  };

  let resizeObserver = null;

  function init() {
    const root = document.querySelector('[data-cs-root]');
    if (!root) return;
    const canvas = root.querySelector('[data-cs-flow-canvas]');
    if (!canvas) return;

    canvas.innerHTML = renderEmpty();

    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-cs-flow]');
      if (btn) {
        const flowId = btn.dataset.csFlow;
        selectFlow(root, flowId, btn);
        return;
      }
      const pillHead = e.target.closest('[data-cs-pill]');
      if (pillHead) {
        togglePill(canvas, pillHead);
        return;
      }
    });

    root.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const pillHead = e.target.closest('[data-cs-pill]');
      if (pillHead && e.target === pillHead) {
        e.preventDefault();
        togglePill(canvas, pillHead);
      }
    });
  }

  function selectFlow(root, flowId, btn) {
    const flow = FLOWS[flowId];
    if (!flow) return;
    root.querySelectorAll('.nc-cs__process-btn').forEach(b => b.classList.remove('is-selected'));
    btn.classList.add('is-selected');
    const canvas = root.querySelector('[data-cs-flow-canvas]');
    const titleEl = root.querySelector('[data-cs-flow-title]');
    if (titleEl) titleEl.textContent = flow.name;
    canvas.innerHTML = renderFlow(flow);
    setupConnectors(canvas);
  }

  function togglePill(canvas, pill) {
    const step = pill.getAttribute('data-cs-step');
    const wasExpanded = pill.getAttribute('aria-expanded') === 'true';
    canvas.querySelectorAll('[data-cs-pill][aria-expanded="true"]').forEach(p => {
      p.setAttribute('aria-expanded', 'false');
    });
    canvas.querySelectorAll('[data-cs-description-cell].is-expanded').forEach(c => {
      c.classList.remove('is-expanded');
    });
    if (!wasExpanded) {
      pill.setAttribute('aria-expanded', 'true');
      const descCell = canvas.querySelector(`[data-cs-description-cell="${step}"]`);
      if (descCell) descCell.classList.add('is-expanded');
    }
    requestAnimationFrame(() => drawConnectors(canvas));
  }

  function setupConnectors(canvas) {
    if (resizeObserver) resizeObserver.disconnect();
    const rows = canvas.querySelector('[data-cs-rows]');
    if (!rows) return;
    drawConnectors(canvas);
    resizeObserver = new ResizeObserver(() => drawConnectors(canvas));
    resizeObserver.observe(rows);
  }

  function drawConnectors(canvas) {
    const rows = canvas.querySelector('[data-cs-rows]');
    const svg = canvas.querySelector('[data-cs-connectors]');
    if (!rows || !svg) return;
    const pills = Array.from(rows.querySelectorAll('[data-cs-pill]'));
    if (pills.length < 2) { svg.innerHTML = ''; return; }

    const rowsRect = rows.getBoundingClientRect();
    svg.setAttribute('viewBox', `0 0 ${rowsRect.width} ${rowsRect.height}`);
    svg.setAttribute('preserveAspectRatio', 'none');

    // Anchor X on the lane column center, not the pill's bounding box center, so expanded pills don't drag arrows to the row middle.
    const rowsStyle = getComputedStyle(rows);
    const padLeft = parseFloat(rowsStyle.paddingLeft) || 0;
    const padRight = parseFloat(rowsStyle.paddingRight) || 0;
    const gridWidth = rowsRect.width - padLeft - padRight;
    const colWidth = gridWidth / 2;
    const humanX = padLeft + colWidth / 2;
    const agentX = padLeft + colWidth * 1.5;

    let paths = `<defs><marker id="nc-vswim-arr" viewBox="0 0 8 8" refX="7" refY="4" markerWidth="7" markerHeight="7" orient="auto"><path d="M0,0 L8,4 L0,8 Z" fill="#000000"/></marker></defs>`;
    for (let i = 0; i < pills.length - 1; i++) {
      const a = pills[i].getBoundingClientRect();
      const b = pills[i + 1].getBoundingClientRect();
      const aCell = pills[i].parentElement;
      const bCell = pills[i + 1].parentElement;
      const ax = aCell && aCell.classList.contains('nc-vswim__cell--human') ? humanX : agentX;
      const bx = bCell && bCell.classList.contains('nc-vswim__cell--human') ? humanX : agentX;
      const ay = a.bottom - rowsRect.top;
      const by = b.top - rowsRect.top - 2;
      let d;
      if (Math.abs(ax - bx) < 1) {
        d = `M ${ax} ${ay} L ${bx} ${by}`;
      } else {
        const midY = (ay + by) / 2;
        d = `M ${ax} ${ay} L ${ax} ${midY} L ${bx} ${midY} L ${bx} ${by}`;
      }
      paths += `<path d="${d}" fill="none" stroke="#000000" stroke-width="1" marker-end="url(#nc-vswim-arr)"/>`;
    }
    svg.innerHTML = paths;
  }

  function computeCounts(steps) {
    const c = { total: steps.length, human: 0, agent: 0, live: 0, partial: 0, planned: 0 };
    steps.forEach(s => {
      if (s.lane === 'Human') c.human++;
      else if (s.lane === 'Agent') c.agent++;
      const key = (s.status || '').toLowerCase();
      if (key === 'live') c.live++;
      else if (key === 'partial') c.partial++;
      else if (key === 'planned') c.planned++;
    });
    return c;
  }

  function renderEmpty() {
    return `<div class="nc-vswim nc-vswim--empty">
      <div class="nc-vswim__board">
        <div class="nc-vswim__divider" aria-hidden="true"></div>
        <div class="nc-vswim__lanes-header">
          <h3 class="nc-vswim__lane-label">${HUMAN_ICON}<span>Human</span></h3>
          <h3 class="nc-vswim__lane-label">${AGENT_ICON}<span>Agent</span></h3>
        </div>
        <div class="nc-vswim__empty-hint">Select a process above to see its flow.</div>
      </div>
    </div>`;
  }

  function renderFlow(flow) {
    const counts = computeCounts(flow.steps);
    let html = `<article class="nc-vswim" data-flow-slug="${escapeHtml(flow.slug)}">`;

    html += `<div class="nc-vswim__meta">`;
    if (flow.description) {
      html += `<p class="nc-vswim__description">${escapeHtml(flow.description)}</p>`;
    }
    html += renderConsolidatedLegend(counts);
    html += `</div>`;

    html += `<div class="nc-vswim__board">`;
    html += `<div class="nc-vswim__divider" aria-hidden="true"></div>`;
    html += `<div class="nc-vswim__lanes-header">`;
    html += `<h3 class="nc-vswim__lane-label">${HUMAN_ICON}<span>Human</span></h3>`;
    html += `<h3 class="nc-vswim__lane-label">${AGENT_ICON}<span>Agent</span></h3>`;
    html += `</div>`;

    html += `<div class="nc-vswim__rows" data-cs-rows>`;
    html += `<svg class="nc-vswim__connectors" data-cs-connectors aria-hidden="true" xmlns="http://www.w3.org/2000/svg"></svg>`;
    flow.steps.forEach(step => { html += renderRow(step); });
    html += `</div>`;

    html += `</div>`;

    html += `</article>`;
    return html;
  }

  function renderRow(step) {
    const pillLaneClass = step.lane === 'Human' ? 'nc-vswim__cell--human' : 'nc-vswim__cell--agent';
    const descLaneClass = step.lane === 'Human' ? 'nc-vswim__cell--agent' : 'nc-vswim__cell--human';
    let html = `<div class="nc-vswim__cell ${pillLaneClass}" style="grid-row: ${step.number};">${renderPill(step)}</div>`;
    html += `<div class="nc-vswim__cell ${descLaneClass} nc-vswim__description-cell" style="grid-row: ${step.number};" data-cs-description-cell="${step.number}">`;
    html += renderDescriptionBody(step);
    html += `</div>`;
    return html;
  }

  function renderDescriptionBody(step) {
    if (!step.description) return '';
    return `<div class="nc-vswim__description-body"><p class="nc-vswim__description-text">${escapeHtml(step.description)}</p></div>`;
  }

  function renderPill(step) {
    const statusClass = statusKeyOf(step.status);
    const num = String(step.number).padStart(2, '0');
    const detailId = `nc-vswim-detail-${step.number}`;
    const plusIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="M12 5v14"/></svg>';

    let html = `<button type="button" class="nc-vswim__pill" data-cs-pill data-cs-step="${step.number}" aria-expanded="false" aria-controls="${detailId}">`;
    html += `<span class="nc-vswim__pill-main">`;
    html += `<span class="nc-vswim__pill-head">`;
    html += `<span class="nc-vswim__pill-num">${escapeHtml(num)}</span>`;
    html += `<span class="nc-vswim__pill-dot nc-vswim__pill-dot--${statusClass}" aria-hidden="true"></span>`;
    html += `<span class="nc-vswim__pill-title">${escapeHtml(step.title)}</span>`;
    html += `<span class="nc-vswim__pill-chevron" aria-hidden="true">${plusIcon}</span>`;
    html += `</span>`;
    html += renderPillRow('tools',  'Tools',  TOOLBOX_ICON, normalizeList(step.tool));
    html += renderPillRow('input',  'Input',  ENTER_ICON,   normalizeList(step.input));
    html += renderPillRow('output', 'Output', EXIT_ICON,    normalizeList(step.output));
    html += `</span>`;
    html += `</button>`;
    return html;
  }

  function renderPillRow(kind, label, icon, items) {
    if (!items.length) return '';
    let html = `<span class="nc-vswim__pill-row nc-vswim__pill-row--${kind}">`;
    html += `<span class="nc-vswim__pill-row-icon" aria-hidden="true">${icon}</span>`;
    html += `<span class="nc-vswim__pill-row-pills" aria-label="${escapeHtml(label)}">`;
    items.forEach(item => {
      html += `<span class="nc-vswim__tool">${escapeHtml(capitalize(item))}</span>`;
    });
    html += `</span>`;
    html += `</span>`;
    return html;
  }

  function renderConsolidatedLegend(counts) {
    const plain = (num, label) =>
      `<span class="nc-vswim__legend-item">${num} ${label}</span>`;
    const dot = (num, label, kind) =>
      `<span class="nc-vswim__legend-item"><span class="nc-vswim__legend-dot nc-vswim__legend-dot--${kind}" aria-hidden="true"></span>${num} ${label}</span>`;
    const icon = (svg, label, kind) =>
      `<span class="nc-vswim__legend-item nc-vswim__legend-item--${kind}"><span class="nc-vswim__legend-icon" aria-hidden="true">${svg}</span>${label}</span>`;

    return `<div class="nc-vswim__legend" aria-label="Flow summary">`
      + plain(counts.total, 'Steps')
      + plain(counts.human, 'Human')
      + plain(counts.agent, 'Agent')
      + dot(counts.live, 'Live', 'live')
      + dot(counts.partial, 'Partial', 'partial')
      + dot(counts.planned, 'Planned', 'planned')
      + icon(TOOLBOX_ICON, 'Tools', 'tools')
      + icon(ENTER_ICON, 'Input', 'input')
      + icon(EXIT_ICON, 'Output', 'output')
      + `</div>`;
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, ch => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[ch]));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
